var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-social-network",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6987 0C13.5342 0 10.4408 0.938384 7.80961 2.69649C5.17843 4.45459 3.12767 6.95345 1.91667 9.87706C0.705663 12.8007 0.38881 16.0177 1.00617 19.1214C1.62354 22.2251 3.14739 25.0761 5.38503 27.3137C7.62267 29.5513 10.4736 31.0752 13.5773 31.6926C16.681 32.3099 19.8981 31.9931 22.8217 30.7821C25.7453 29.5711 28.2441 27.5203 30.0022 24.8891C31.7604 22.2579 32.6987 19.1645 32.6987 16C32.6987 11.7565 31.013 7.68687 28.0124 4.68629C25.0119 1.68571 20.9422 0 16.6987 0ZM19.5793 17.4926H17.1439V24.275H13.5433V17.4926H11.828V14.4615H13.5433V12.4975C13.5433 11.09 14.1979 8.8838 17.1832 8.8838H19.8608V11.8298H17.8968C17.7887 11.8219 17.6803 11.8383 17.5794 11.8778C17.4785 11.9172 17.3877 11.9787 17.3136 12.0578C17.2396 12.1369 17.1841 12.2315 17.1514 12.3348C17.1186 12.4381 17.1093 12.5474 17.1243 12.6547V14.4419H19.8739L19.5793 17.4926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1ba97fcf595b6cbc3055d2f41b5ff0b6.svg";
export { ForwardRef as ReactComponent };